import styled from '@emotion/styled'

export const SettingsIconContainer = styled.div`
  margin-left: auto;
  height: 24px;
  width: 24px;
`
